import React, { useMemo, useRef } from 'react';
import { LetterWrapperProp, LineWrapperProp, SplitText, WordWrapperProp } from '@cyriacbr/react-split-text';
import { LetterByLetterInterface } from './letter-by-letter.interface';
import styles from './letter-by-letter.module.scss';
import useIntersection from '../../hooks/use-intersection';
import classNames from 'classnames';

const LetterByLetter: React.FunctionComponent<LetterByLetterInterface> = ({
  text,
}) => {
  const componentRef = useRef() as React.MutableRefObject<HTMLParagraphElement>;
  const isComponentInView = useIntersection({
    ref: componentRef,
    options: {
      rootMargin: '-50px',
    },
  });

  const LetterWrapper: React.FC<LetterWrapperProp> = ({
    countIndex,
    children,
  }) => {
    return (
      <span
        key={countIndex}
        className={styles.letter}
        style={{
          '--letter-index': countIndex,
        } as React.CSSProperties}
        children={children}
      />
    );
  };

  const WordWrapper: React.FC<WordWrapperProp> = ({
    wordIndex,
    children,
  }) => {
    // @ts-ignore
    const text = children.map(thisItem => thisItem.props.children).join('').trim();

    return (
      <span
        key={wordIndex}
        className={styles.word}
        children={
          ['Forbes', 'Meta'].includes(text)
            ? <b>{children}</b>
            : children
        }
      />
    );
  };

  const LineWrapper: React.FC<LineWrapperProp> = ({
    lineIndex,
    children,
  }) => {
    return (
      <span
        key={lineIndex}
        className={styles.line}
        style={{
          '--line-index': lineIndex,
        } as React.CSSProperties}
      >
        <span
          className={styles.originalLine}
          children={children}
        />
        <span
          className={styles.twinLine}
          children={children}
        />
      </span>
    );
  };

  const MemoizedLetterWrapper = useMemo(() => LetterWrapper, []);
  const MemoizedWordWrapper = useMemo(() => WordWrapper, []);
  const MemoizedLineWrapper = useMemo(() => LineWrapper, []);

  return (
    <span
      ref={componentRef}
      className={classNames(
        styles.component,
        {
          [styles.isInViewport]: isComponentInView,
        },
      )}
    >
      <SplitText
        LetterWrapper={MemoizedLetterWrapper}
        WordWrapper={MemoizedWordWrapper}
        LineWrapper={MemoizedLineWrapper}
        children={text}
      />
    </span>
  );
};

export default LetterByLetter;
